import Api from '../base/index.js'

export default{
    async index(page=1){
        return Api.get(`section?page=${page}`)
    },

    async all(){
        return Api.get(`section-all`)
    },

    async create(data){
        return Api.post(`section`, data)
    },

    async update(id, data){
        return Api.put(`section/${id}`, data)
    },
    async delete(id){
        return Api.delete(`section/${id}`)
    }
}